<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.5011 2.75227C3.5011 2.33806 3.16531 2.00227 2.7511 2.00227C2.33689 2.00227 2.0011 2.33806 2.0011 2.75227L2.0011 17.2477C2.0011 17.6619 2.33689 17.9977 2.7511 17.9977C3.16531 17.9977 3.5011 17.6619 3.5011 17.2477L3.5011 2.75227Z"
      fill="currentColor"
    />
    <path
      d="M18 2.75227C18 2.33806 17.6642 2.00227 17.25 2.00227C16.8358 2.00227 16.5 2.33806 16.5 2.75227L16.5 17.2477C16.5 17.6619 16.8358 17.9977 17.25 17.9977C17.6642 17.9977 18 17.6619 18 17.2477L18 2.75227Z"
      fill="currentColor"
    />
    <path
      d="M5 8C5 7.44772 5.44772 7 6 7H14C14.5523 7 15 7.44772 15 8V12C15 12.5523 14.5523 13 14 13H6C5.44772 13 5 12.5523 5 12V8Z"
      fill="currentColor"
    />
  </svg>
</template>
